import React from 'react';
import Button from '../ui/button';
import SectionBackground from '../sections/section-background';
import Breadcrumb from '../ui/breadcrumb';

interface HeroTemplateProps {
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  imageUrl: string;
  cta1?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  cta2?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  page: string;
  section?: string;
  breadcrumbs?: {
    name: string;
    href: string;
  }[];
}

export default function HeroTemplateEnts({
  title,
  description,
  imageUrl,
  cta1,
  cta2,
  page,
  section = 'hero',
  breadcrumbs,
}: HeroTemplateProps) {
  return (
    <SectionBackground
      page={page}
      section={section}
      className="relative overflow-hidden bg-gradient-to-br from-[#e0f2ff] via-[#f3e8ff] to-[#fdf4ff]"
    >
      {/* Image droite */}
      <div className="absolute inset-0 z-0 flex justify-end items-center pointer-events-none select-none">
        <img
          src={imageUrl}
          alt="Illustration recrutement IA"
          className="h-[75%] object-contain max-h-[600px] md:pr-[5vw] opacity-20 md:opacity-100"
        />
      </div>

      <section className="min-h-[85vh] flex items-center relative z-10">
        <div className="w-full px-[5vw] xl:px-[100px] max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-12">
          <div className="max-w-2xl">

            {/* ✅ H1 SEO caché */}
            <h1 className="sr-only">
              {typeof description === 'string'
                ? description
                : 'Cabinet de recrutement innovant combinant IA et expertise RH'}
            </h1>

            {/* ✅ Titre visuel */}
            <div className="text-5xl md:text-6xl lg:text-7xl font-title font-extrabold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
              {title}
            </div>

            {breadcrumbs && (
              <div className="my-4">
                <Breadcrumb items={breadcrumbs} />
              </div>
            )}

            <div className="mt-6 mb-8 text-neutral-800 text-lg md:text-xl leading-relaxed">
              {description}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              {cta1 && (
                <Button
                  variant="gradient"
                  size="lg"
                  href={cta1.href}
                  onClick={cta1.onClick}
                >
                  {cta1.label}
                </Button>
              )}
              {cta2 && (
                <Button
                  variant="secondary"
                  size="lg"
                  href={cta2.href}
                  onClick={cta2.onClick}
                >
                  {cta2.label}
                </Button>
              )}
            </div>
          </div>
        </div>
      </section>
    </SectionBackground>
  );
}